/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useTranslation } from 'react-i18next';
import useChart from './chart';
import Widget from '../../widget';
import { defaultData } from './helper';
import styled from 'styled-components';
import DashboardPopover from '../../../../components/dashboards/components/Popover';

export const Style = styled.div`
  flex: 1;
  max-width: calc(50% - 12px);

  .chart-cont {
    height: 300px;
    width: calc(100% - 48px);
    margin-left: var(--size-lg);
  }
`;

const AssessmentPerformance = ({ data = defaultData, loading, isSingleSource }) => {
  const { t } = useTranslation();
  const { container } = useChart({ data, t });

  return (
    <Style>
      <Widget
        title={t('Assessment Performance')}
        className="no-px-body"
        loading={loading}
        tooltip={(
          <DashboardPopover
            title={t('Assessment Performance')}
            body={t(
              isSingleSource ?
                'Compliance assessment of the counterparty based on available information, as per the Assessment Details.'
                : 'Compliance assessment of the counterparty based on information available from selected sources.'
            )}
          />
        )}
      >
        <div ref={container} className="chart-cont" />
      </Widget>
    </Style>
  );
};

export default AssessmentPerformance;
